import React, { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../context/GlobalContext';
import Table from 'react-bootstrap/Table';

const DataTable = () => {
  let num = 1;

  const { contextState, contextFunctions } = useContext(GlobalContext);

  const { arr, arrJob, setArr, fetchStatus, setFetchStatus } = contextState;

  const { renderData, showStatus, handleDelete, handleEdit, showContentTable } =
    contextFunctions;

  const [dataJob, setDataJob] = useState(null);
  const [queryTitle, setQueryTitle] = useState('');
  const [filter, setFilter] = useState({
    company_name: '',
    company_city: '',
    job_type: '',
  });
  const searchChange = (event) => {
    setQueryTitle(event.target.value);
  };

  const submitSearch = (event) => {
    event.preventDefault();
    const search = arr.filter((el) => {
      return Object.values(el)
        .join(' ')
        .toLowerCase()
        .includes(queryTitle.toLowerCase());
    });
    setArr(search);
    setQueryTitle('');
  };

  const handleChangeFilter = (event) => {
    setFilter({ ...filter, [event.target.name]: event.target.value });
  };

  const handleFilter = (event) => {
    event.preventDefault();
    const filtered = arr.filter((el) => {
      return (
        el.company_name === filter.company_name ||
        el.company_city === filter.company_city ||
        el.job_type === filter.job_type
      );
    });
    setArr(filtered);
    setFilter({ company_name: '', company_city: '', job_type: '' });
  };

  useEffect(() => {
    if (fetchStatus === true) {
      renderData();
    }
  }, [fetchStatus, setFetchStatus]);
  return (
    <div className="col-10 data-tabel">
      <div className="container mb-5">
        <div className="container mt-3">
          <form onSubmit={submitSearch}>
            <div className="col-auto">
              <label htmlFor="title" className="form-label">
                Search
              </label>
              <input
                type="text"
                name="title"
                className="form-control"
                onChange={searchChange}
                value={queryTitle}
                placeholder="Cari Posisi..."
              />
            </div>
            <div className="float-right ">
              <button
                className="btn btn-primary rounded-pill mt-2 float-end"
                type="submit"
              >
                Cari
              </button>
              <button
                className="btn btn-danger rounded-pill mt-2 float-end"
                type="submit"
                onClick={() => setFetchStatus(true)}
              >
                Reset Data
              </button>
            </div>
          </form>
        </div>

        <div className="container mt-5 mb-5">
          <h4 className="mt-3">Filter Data</h4>
          <form onSubmit={handleFilter}>
            <div className=" col-12">
              <label htmlFor="company_name" className="form-label">
                Cari Perusahaan
              </label>
              <input
                type="text"
                name="company_name"
                className="form-control"
                onChange={handleChangeFilter}
                value={filter.company_name}
                placeholder="Cari Perusahaan..."
              />
            </div>
            <div className=" col-12">
              <label htmlFor="company_city" className="form-label">
                Cari Kota
              </label>
              <input
                type="text"
                name="company_city"
                className="form-control"
                onChange={handleChangeFilter}
                value={filter.company_city}
                placeholder="Cari Kota..."
              />
            </div>
            <div className=" col-12">
              <label htmlFor="job_type" className="form-label">
                Tipe Pekerjaan
              </label>
              <input
                className="form-control"
                type="text"
                name="job_type"
                onChange={handleChangeFilter}
                value={filter.job_type}
                placeholder="Tipe Pekerjaan..."
              />
            </div>
            <div className="float-right">
              <button
                className="btn btn-primary rounded-pill mt-2 float-end"
                type="submit"
              >
                Filter
              </button>
            </div>
          </form>
        </div>
      </div>
      <h1 className="text-center">Data Pekerjaan</h1>
      <table className="table table-hover table-dark table-bordered table-striped">
        <thead>
          <tr>
            <th>No</th>
            <th>Pekerjaan</th>
            <th>Deskripsi</th>
            <th>Kualifikasi Pekerjaan</th>
            <th>Tipe Pekerjaan</th>
            <th>Kontrak Pekerjaan</th>
            <th>Status Pekerjaan</th>
            <th>Nama Perusahaan</th>
            <th>Gambar</th>
            <th>Kota</th>
            <th>Gaji Min</th>
            <th>Gaji Max</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {arr !== null ? (
            arr.map((el) => (
              <tr key={el.id}>
                <td>{num++}</td>
                <td>{el.title}</td>
                <td>{showContentTable(el.job_description)}</td>
                <td>{showContentTable(el.job_qualification)}</td>
                <td>{el.job_type}</td>
                <td>{el.job_tenure}</td>
                <td>{showStatus(el.job_status)}</td>
                <td>{el.company_name}</td>
                <td>
                  <img src={el.company_image_url} style={{ width: '100px' }} />{' '}
                </td>
                <td>{el.company_city}</td>
                <td>{el.salary_min}</td>
                <td>{el.salary_max}</td>
                <td className="flex gap-2">
                  <button
                    onClick={handleEdit}
                    value={el.id}
                    className="btn btn-warning fw-bold p-3"
                  >
                    Edit
                  </button>
                  <button
                    onClick={handleDelete}
                    value={el.id}
                    className="btn btn-danger fw-bold p-3"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td>Tidak ada data</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;
